module.exports = __webpack_public_path__ + "img/Paginierung_Empty.9bf6fe2b.svg";